import { useMutation, useQueryClient } from "@tanstack/react-query";
import { liveProgressApi } from "./api/liveProgress";
import { programmeDashboardApi } from "../programmeDashboard/api/programmeDashboard";

export const useLiveProgressMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (params?: string) => {
      return await liveProgressApi.fetchLiveProgress(params);
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["live-progress"] });
    },
  });
};

export const useLiveProgressProjectsMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (params?: { page?: number; limit?: number }) => {
      return await liveProgressApi.fetchProjects(params);
    },
    onSuccess: async (_, variables) => {
      await qc.refetchQueries({
        queryKey: ["live-progress-projects", variables],
      });
    },
  });
};

export const useLiveProgressRisksMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return await programmeDashboardApi.fetchRisks({
        page: 1,
        limit: 100,
        sort_field: "risk_id",
        sort_order: "DESC",
        status: "open",
      });
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["live-progress-risks"] });
    },
  });
};
